/**
 * NativeWaves EXP API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AppsApi extends runtime.BaseAPI {
    /**
     * [ORIGIN] Get a EXP app config without disabled and unused elements.
     */
    async appsAppIdConfigGetRaw(requestParameters, initOverrides) {
        if (requestParameters.appId === null ||
            requestParameters.appId === undefined) {
            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling appsAppIdConfigGet.');
        }
        const queryParameters = {};
        if (requestParameters.full !== undefined) {
            queryParameters['full'] = requestParameters.full;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/apps/{appId}/config`.replace(`{${'appId'}}`, String(requestParameters.appId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * [ORIGIN] Get a EXP app config without disabled and unused elements.
     */
    async appsAppIdConfigGet(requestParameters, initOverrides) {
        const response = await this.appsAppIdConfigGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an EXP app.
     */
    async appsAppIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.appId === null ||
            requestParameters.appId === undefined) {
            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling appsAppIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/apps/{appId}`.replace(`{${'appId'}}`, String(requestParameters.appId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an EXP app.
     */
    async appsAppIdDelete(requestParameters, initOverrides) {
        await this.appsAppIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an EXP app.
     */
    async appsAppIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.appId === null ||
            requestParameters.appId === undefined) {
            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling appsAppIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/apps/{appId}`.replace(`{${'appId'}}`, String(requestParameters.appId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an EXP app.
     */
    async appsAppIdGet(requestParameters, initOverrides) {
        const response = await this.appsAppIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an EXP app.
     */
    async appsAppIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.appId === null ||
            requestParameters.appId === undefined) {
            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling appsAppIdPatch.');
        }
        if (requestParameters.expAppEdit === null ||
            requestParameters.expAppEdit === undefined) {
            throw new runtime.RequiredError('expAppEdit', 'Required parameter requestParameters.expAppEdit was null or undefined when calling appsAppIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/apps/{appId}`.replace(`{${'appId'}}`, String(requestParameters.appId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.expAppEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an EXP app.
     */
    async appsAppIdPatch(requestParameters, initOverrides) {
        const response = await this.appsAppIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * [ORIGIN] Get the resolved and slimmed version of an EXP app config (no disabled and unused elements) and resolved for the specified manifest.
     */
    async appsAppIdResolvedConfigsManifestIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.appId === null ||
            requestParameters.appId === undefined) {
            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling appsAppIdResolvedConfigsManifestIdGet.');
        }
        if (requestParameters.manifestId === null ||
            requestParameters.manifestId === undefined) {
            throw new runtime.RequiredError('manifestId', 'Required parameter requestParameters.manifestId was null or undefined when calling appsAppIdResolvedConfigsManifestIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/apps/{appId}/resolvedConfigs/{manifestId}`
                .replace(`{${'appId'}}`, String(requestParameters.appId))
                .replace(`{${'manifestId'}}`, String(requestParameters.manifestId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * [ORIGIN] Get the resolved and slimmed version of an EXP app config (no disabled and unused elements) and resolved for the specified manifest.
     */
    async appsAppIdResolvedConfigsManifestIdGet(requestParameters, initOverrides) {
        const response = await this.appsAppIdResolvedConfigsManifestIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of EXP apps. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async appsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling appsGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/apps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of EXP apps. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async appsGet(requestParameters, initOverrides) {
        const response = await this.appsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new EXP app.
     */
    async appsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.expAppInsert === null ||
            requestParameters.expAppInsert === undefined) {
            throw new runtime.RequiredError('expAppInsert', 'Required parameter requestParameters.expAppInsert was null or undefined when calling appsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/apps`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.expAppInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new EXP app.
     */
    async appsPost(requestParameters, initOverrides) {
        const response = await this.appsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AppsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
//# sourceMappingURL=AppsApi.js.map